import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isFunction } from 'lodash-es'
import { FormattedMessage } from 'react-intl'

import { TtIcon } from '@23/ui-react'

import { ConditionWrapComponent, IconComponent } from '../../../../components'

import './PollAnsweredComponent.scss'

const PollAnsweredComponent = (props) => {
  const { renderPollUnitWrapper, iconColor, closeIconColor } = props

  const [isClosed, setIsClosed] = useState(false)

  if (isClosed) {
    return null
  }

  return (
    <ConditionWrapComponent
      condition={isFunction(renderPollUnitWrapper)}
      wrap={(children) => renderPollUnitWrapper({ children })}
    >
      <div className="poll-answered-component">
        <div className="check-icon-wrapper">
          <IconComponent
            name="check"
            size={[16, 16]}
            color={iconColor.replace('#', '')}
          />
        </div>
        <div className="message">
          <FormattedMessage defaultMessage="Thank you for your answer." />
        </div>
        <div className="close-message">
          <TtIcon
            style={{ color: closeIconColor }}
            name="close"
            onClick={() => setIsClosed(true)}
          />
        </div>
      </div>
    </ConditionWrapComponent>
  )
}

PollAnsweredComponent.propTypes = {
  renderPollUnitWrapper: PropTypes.func,
  iconColor: PropTypes.string,
  closeIconColor: PropTypes.string,
}

PollAnsweredComponent.defaultProps = {
  iconColor: '1EC95B',
}

export default PollAnsweredComponent
